import BookStore from '../stores/book-store';

export default {

  goToHighlight(isbn, highlight) {
    const book = BookStore.get(isbn);
    book.viewer.Book.goToHighlight(highlight);
  }

};
